import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {Subject} from 'rxjs';
import { UtilityService } from '../utility_functions/utility_functions.service';

@Injectable()
export class MyCustomPaginatorIntl implements MatPaginatorIntl {

  changes = new Subject<void>();

  firstPageLabel = `${this.utilityService.getLocaleValue('text.first_page','First page')}`;
  itemsPerPageLabel = `${this.utilityService.getLocaleValue('text.items_per_page', 'Items per page')}`;
  lastPageLabel = `${this.utilityService.getLocaleValue('text.last_page','Last page')}`;

  // You can set labels to an arbitrary string too, or dynamically compute
  // it through other third-party internationalization libraries.
  nextPageLabel = `${this.utilityService.getLocaleValue('text.next_page','Next page')}`;
  previousPageLabel = `${this.utilityService.getLocaleValue('text.previous_page','Previous page')}`;

  constructor(private utilityService: UtilityService) {}

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `${this.utilityService.getLocaleValue('text.page', 'Page')} 1 ${this.utilityService.getLocaleValue('of.label', 'of')} 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `${this.utilityService.getLocaleValue('text.page', 'Page')} ${page + 1} ${this.utilityService.getLocaleValue('of.label', 'of')} ${amountPages}`;
  }
};
